import { render, staticRenderFns } from "./CalendarNote.vue?vue&type=template&id=53222a86"
import script from "./CalendarNote.vue?vue&type=script&lang=js"
export * from "./CalendarNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports